import { GuideComponent } from './guide/guide.component';
import { PipesModule } from './../../pipes/pipes.module';
import { PickCountryComponent } from './pick-country/pick-country.component';
import { CguComponent } from './cgu/cgu.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { DetailOffreComponent } from './detail-offre/detail-offre.component';
import { PostulerComponent } from './postuler/postuler.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PickActionComponent } from './pick-action/pick-action.component';
import { IonicModule } from '@ionic/angular';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { GlobalFilterComponent } from './global-filter/global-filter.component';
import { OffreListComponent } from './offre-list/offre-list.component';
import { LoginComponent } from './login/login.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { UserInfosComponent } from './user-infos/user-infos.component';

@NgModule({
  declarations: [PickActionComponent,
    GlobalFilterComponent,
    OffreListComponent,
    LoginComponent,
    PostulerComponent,
    DetailOffreComponent,
    ChangePasswordComponent,
    ContactUsComponent,
    PickCountryComponent,
    CguComponent,
    UserInfosComponent,
    GuideComponent],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    NgxDatatableModule,
    FormsModule,
    PipesModule
  ],
  exports: [
    PickActionComponent,
    GlobalFilterComponent,
    OffreListComponent,
    LoginComponent,
    PostulerComponent,
    DetailOffreComponent,
    PickCountryComponent,
    CguComponent,
    ChangePasswordComponent,
    UserInfosComponent,
    GuideComponent
  ],
  entryComponents: [
    LoginComponent,
    PostulerComponent,
    DetailOffreComponent,
    ChangePasswordComponent,
    ContactUsComponent,
    CguComponent,
    PickCountryComponent,
    UserInfosComponent,
    GuideComponent]
})
export class ComponentsModule { }
